import {Backbone} from 'Vertebrae';
import {ProfileUser} from 'model/profileUser';

export const SimilarExperts = Backbone.Collection.extend({
    _name: 'experts', //we're using the old relatedExperts hook which wraps it in "experts"
    model: ProfileUser,
    url: '/api/expert/relatedExperts.json',
});
